import React, { useRef, useState } from 'react';
import { searchIcon } from './icons';

const SearchFilter = (props) => {
    const inputRef = useRef(null);
    const [searchValue, setSearchValue] = useState('');
    
    const filterList = (e) => {
        e.preventDefault(); // Prevent page reload
        let searchText = e.target.value;
        setSearchValue(searchText);
        props.filterList(searchText.toLowerCase());
    };

    // Handle blur events to restore focus if lost during re-render
    const handleBlur = (e) => {
        // Persist the event to prevent React from nullifying it
        e.persist();
        // Store target reference immediately before async operations
        const inputElement = e.target;
        const currentValue = searchValue;
        
        // Check where focus actually went after a short delay
        // This handles both click events (which may not set relatedTarget) and re-renders
        setTimeout(() => {
            const newActiveElement = document.activeElement;
            const input = inputRef.current || inputElement;
            
            // Check if focus moved to another input/textarea/select/button or contenteditable
            const isBlurringToAnotherInput = newActiveElement?.tagName === 'INPUT' || 
                                             newActiveElement?.tagName === 'TEXTAREA' ||
                                             newActiveElement?.tagName === 'SELECT' ||
                                             newActiveElement?.tagName === 'BUTTON' ||
                                             newActiveElement?.contentEditable === 'true' ||
                                             newActiveElement?.getAttribute('contenteditable') === 'true' ||
                                             newActiveElement?.tagName === 'IFRAME' ||
                                             newActiveElement?.closest('iframe') !== null;
            
            // Check if focus is inside an editor container (TinyMCE, contenteditable divs, etc)
            const editorContainers = document.querySelectorAll('[id*="editor"], [id*="Editor"], [class*="editor"], [class*="Editor"], #step-content, #step-content-container, .tox-tinymce');
            const isInsideEditor = Array.from(editorContainers).some(container => {
                return container.contains(newActiveElement) || container === newActiveElement;
            });
            
            // Only restore focus if:
            // 1. Focus didn't go to another input/textarea/etc
            // 2. Focus is not inside an editor container
            // 3. This input is not currently focused
            // 4. The input still exists in the DOM
            if (!isBlurringToAnotherInput && !isInsideEditor && input && document.activeElement !== input) {
                // Check if user clicked on a clickable element (like buttons, links, etc)
                const clickedElement = document.activeElement;
                const isClickableElement = clickedElement?.onclick !== null || 
                                          clickedElement?.getAttribute('role') === 'button' ||
                                          clickedElement?.classList.contains('clickable') ||
                                          clickedElement?.closest('button') !== null ||
                                          clickedElement?.closest('a') !== null;
                
                // Don't restore if user clicked on a clickable element
                if (!isClickableElement) {
                    input.focus();
                    // Restore cursor position if there's text
                    if (input.setSelectionRange && currentValue) {
                        const cursorPos = Math.min(currentValue.length, input.value.length);
                        input.setSelectionRange(cursorPos, cursorPos);
                    }
                }
            }
        }, 50); // Small delay to let click events complete
    };

    return (
        <form className="search-form flex max-width" style={props.style}>
            {searchIcon}
            <input
                ref={inputRef}
                type="search"
                onChange={filterList}
                onBlur={handleBlur}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent page reload
                    }
                }}
                name="search"
                placeholder={props.placeholder || 'Search...'}
                value={searchValue}
            />
        </form>
    );
};

export default SearchFilter;
